module.exports = __webpack_public_path__ + "img/img-130.df6eba37.png";